<template>
  <div style="margin-left: 10px; min-height: 80vh;">
    <div class="vm-separate">
      <div>
        <router-link to="/kb/ts" target="_blank">调试区域看板</router-link>
        <br><br>
        <router-link to="/kb/zm" target="_blank">装门区域看板</router-link>
        <br><br>
        <router-link to="/kb/ck" target="_blank">仓库看板</router-link>
        <br><br>
        <router-link to="/kb/bj" target="_blank">部件看板</router-link>
        <br><br>
        <router-link to="/kb/wlb" target="_blank">物流部总看板</router-link>
        <br><br>
        <router-link to="/kb/kzg" target="_blank">控制柜电子看板</router-link>
        <br><br>
        <router-link to="/kb/warehouse/Dq" target="_blank">电气仓电子看板</router-link>
        <br><br>
        <router-link to="/kb/warehouse/Bj" target="_blank">部件仓电子看板</router-link>
        <br><br>
        <router-link to="/kb/warehouse/Middle" target="_blank">中间仓电子看板</router-link>
        <br><br>
        <router-link to="/kb/warehouse/Mipack" target="_blank">小包装电子看板</router-link>
        <br><br>
        <router-link to="/kb/warehouse/MaPack" target="_blank">大包装电子看板</router-link>
        <br><br>
        <router-link to="/kb/warehouse/ShouHuoKanban" target="_blank">收货处看板</router-link>

        <!--        <el-button type="text" @click="goToMa">大包装电子看板</el-button>-->

        <!--        <el-button type="text" @click="goToMi">小包装电子看板</el-button>-->
      </div>
      <div>
        <router-link to="/kb/lsx/1" target="_blank">1号流水线看板</router-link>
        <br><br>
        <router-link to="/kb/lsx/2" target="_blank">2号流水线看板</router-link>
        <br><br>
        <router-link to="/kb/lsx/3" target="_blank">3号流水线看板</router-link>
        <br><br>
        <router-link to="/kb/lsx/4" target="_blank">4号流水线看板</router-link>
        <br><br>
        <router-link to="/kb/lsx/5" target="_blank">5号流水线看板</router-link>
        <br><br>
        <router-link to="/kb/lsx/6" target="_blank">6号流水线看板</router-link>
      </div>
      <div>
        <router-link to="/kb/czbz" target="_blank">操纵包装区域看板</router-link>
        <br><br>
        <router-link to="/kb/wzbz" target="_blank">外召包装区域看板</router-link>
        <br><br>
        <router-link to="/kb/czcs" target="_blank">操纵测试区域看板</router-link>
      </div>
      <div>
        <router-link to="/kb/czlsx/1" target="_blank">1号操纵流水线看板</router-link>
        <br><br>
        <router-link to="/kb/czlsx/2" target="_blank">2号操纵流水线看板</router-link>
        <br><br>
        <router-link to="/kb/czlsx/3" target="_blank">3号操纵流水线看板</router-link>
        <br><br>
        <router-link to="/kb/czlsx/4" target="_blank">4号操纵流水线看板</router-link>
        <br><br>
        <router-link to="/kb/czlsx/5" target="_blank">5号操纵流水线看板</router-link>
        <br><br>
        <router-link to="/kb/czlsx/6" target="_blank">6号操纵流水线看板</router-link>
      </div>
      <div>
        <router-link to="/kb/wzlsx/1" target="_blank">1号外召流水线看板</router-link>
        <br><br>
        <router-link to="/kb/wzlsx/2" target="_blank">2号外召流水线看板</router-link>
        <br><br>
        <router-link to="/kb/wzlsx/3" target="_blank">3号外召流水线看板</router-link>
        <br><br>
        <router-link to="/kb/wzlsx/4" target="_blank">4号外召流水线看板</router-link>
        <br><br>
        <router-link to="/kb/wzlsx/5" target="_blank">5号外召流水线看板</router-link>
        <br><br>
        <router-link to="/kb/wzlsx/6" target="_blank">6号外召流水线看板</router-link>
      </div>
      <div>
        <router-link to="/kb/jdlsx/1" target="_blank">1号轿顶流水线看板</router-link>
        <br><br>
        <router-link to="/kb/jdlsx/2" target="_blank">2号轿顶流水线看板</router-link>
        <br><br>
        <router-link to="/kb/jdlsx/3" target="_blank">3号轿顶流水线看板</router-link>
        <br><br>
        <router-link to="/kb/jdlsx/4" target="_blank">4号轿顶流水线看板</router-link>
        <br><br>
        <router-link to="/kb/jdlsx/5" target="_blank">5号轿顶流水线看板</router-link>
        <br><br>
        <router-link to="/kb/jdlsx/6" target="_blank">6号轿顶流水线看板</router-link>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "Kanban",
    components: {},
    methods: {
      goToMa() {
        window.open("http://192.168.99.126:7180/preview?screenId=84");
      },
      goToMi() {
        window.open("http://192.168.99.126:7180/preview?screenId=86");
      },
    },
  };
</script>
